import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'empty-state',
  templateUrl: 'empty-state.html',
})
export class EmptyStateComponent {
  @Input() imageSource?: string;
  @Input() title?: string;
  @Input() description?: string;
  @Input() buttonText?: string;
  @Input() bottomText?: string;
  @Output('onButtonTap') onButtonTap: EventEmitter<any> = new EventEmitter();

  constructor() {}

  didTapButton() {
    if (this.onButtonTap) {
      this.onButtonTap.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/empty-state/empty-state.ts